import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Intercept responses to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Skip redirect if this is an auth check (has skipAuthRedirect flag)
      const skipAuthRedirect = error.config?.skipAuthRedirect;
      
      // Redirect to login on unauthorized (but not for auth checks or on login/register pages)
      if (!skipAuthRedirect && 
          !window.location.pathname.includes('/login') && 
          !window.location.pathname.includes('/register')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
